import React from 'react';
//HOOKS
import { useZywaveShellReady, useZywaveProxyReady } from 'hooks/useZywaveComponents';
import { useAuthInitialization } from 'hooks/useAuthInitialization';
import { LOGGED_IN_STATE } from 'lib/config/appConstants';
// COMPONENTS
import AppLayoutV2 from 'AppLayoutV2';
import MiZuiSpinner from 'components/common/MiZuiSpinner';

/**
 * AppWrapperV2 Component
 *
 * This component serves as the entry point for the application layout. It ensures that
 * necessary prerequisites (Zywave shell and proxy readiness) are met before rendering
 * the main application layout. Additionally, it initializes Zywave feature monitoring
 * when the user is logged in and the application is ready.
 *
 * @returns {JSX.Element} The application layout or a loading spinner if prerequisites are not met.
 */
const AppWrapperV2: React.FC = () => {
  const shellReady = useZywaveShellReady();
  const proxyReady = useZywaveProxyReady(shellReady);

  const isReady = shellReady && proxyReady;
  const loggedInState = useAuthInitialization(isReady);

  if (!shellReady || !proxyReady || loggedInState === LOGGED_IN_STATE.UNKNOWN) {
    return <MiZuiSpinner />;
  }

  return <AppLayoutV2 />;
};

export default AppWrapperV2;
